import React from "react"
import * as RadixAccordion from "@radix-ui/react-accordion"

export type ToggleableProps = {
  triggerItem: React.ReactNode
  contentItem: React.ReactNode
  defaultValue?: string
  onClick?: () => void
}

export const Toggleable: React.FC<ToggleableProps> = ({
  triggerItem,
  contentItem,
  defaultValue,
  onClick,
}) => {
  return (
    <RadixAccordion.Root type="single" collapsible defaultValue={defaultValue}>
      <RadixAccordion.Item value="item-1">
        <RadixAccordion.Trigger onClick={onClick}>
          {triggerItem}
        </RadixAccordion.Trigger>
        <RadixAccordion.Content className="accordion-content">
          {contentItem}
        </RadixAccordion.Content>
      </RadixAccordion.Item>
    </RadixAccordion.Root>
  )
}
